// services/PublicService.js
import client from "../api/axios";
import ENDPOINTS from "../api/apis";

const publicService = {
  courses: {
    getCourses: async () => {
      const response = await client.get(ENDPOINTS.public.courses.list);
      return response.data?.data;
    },
    getCourse: async (id) => {
      const response = await client.get(ENDPOINTS.public.courses.details(id));
      return response.data?.data;
    }
  },

  internships: {
    getInternships: async () => {
      const response = await client.get(ENDPOINTS.public.internships.list);
      return response.data?.data;
    },
    getInternship: async (id) => {
      const response = await client.get(ENDPOINTS.public.internships.details(id));
      return response.data;
    }
  },
  contactUs:{
    sendMessage:async (message) => {
      const response = await client.post(ENDPOINTS.public.contactus,message);
      return response.data?.data;
    }
  }
};

export default publicService;
